import { getToken } from '@/auth/auth-context'

export const getApiUrl = (url: string) => {
  const apiUrl = import.meta.env.VITE_API_URL as string
  return `${apiUrl}${url}`
}

export const appApiHeaders = () => {
  const token = getToken()
  const authHeader = token ? { Authorization: `Bearer ${token}` } : {}
  return {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    ...authHeader,
  }
}

export const appApiFormDataHeaders = () => {
  const token = getToken()
  const authHeader = token ? { Authorization: `Bearer ${token}` } : {}
  return {
    // Don't set Content-Type for FormData, let the browser handle it
    Accept: 'application/json',
    'Content-Disposition': 'form-data',
    ...authHeader,
  }
}
